import { render, staticRenderFns } from "./ManageGates.vue?vue&type=template&id=5f951922&"
import script from "./ManageGates.vue?vue&type=script&lang=js&"
export * from "./ManageGates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports